<template>
  <div>
    <div class="info-box">
      <div class="info-box-left">
        <div class="background">
          <div style="font-size: 28px;font-weight: bold">{{ knowledgeDetail.question }}</div>
          <div style="display: flex;justify-content: space-between">
            <div style="display: flex;flex-wrap: nowrap;font-size: 14px;color: #8A919F;line-height: 32px;">
              <div style="margin-right: 16px;color: #515767">{{ knowledgeDetail['name@create_user_id'] }}</div>
              <div style="margin-right: 16px">{{ knowledgeDetail.create_time }}</div>
              <div style="display: flex;flex-wrap: nowrap;margin-right: 10px">
                <el-icon :size="14" style="margin-right: 3px;margin-top: 8px;"><ElIconView/></el-icon>
                <div>{{ knowledgeDetail.view_cnt }}</div>
              </div>
              <div style="display: flex;flex-wrap: nowrap;margin-right: 10px">
                <el-icon :size="14" style="margin-right: 3px;margin-top: 8px;"><ElIconStar/></el-icon>
                <div>{{ knowledgeDetail.collect_cnt }}</div>
              </div>
              <div style="line-height: 32px;margin-right: 10px">
                <i class="fa fa-thumbs-o-up" aria-hidden="true" style="font-size: 14px;margin-right: 3px"></i>
                {{ knowledgeDetail.help_cnt }}
              </div>
              <div style="line-height: 32px;margin-right: 10px">
                <i class="fa fa-thumbs-o-down" aria-hidden="true" style="font-size: 14px;margin-right: 3px"></i>
                {{ knowledgeDetail.no_help_cnt }}
              </div>
            </div>
            <div style="display: flex;flex-wrap: nowrap">
              <div>
                <el-tooltip effect="dark" content="收藏" placement="top" v-if="!knowledgeDetail.is_collect">
                  <el-link style="font-size: 12px;" @click="updateCollect">
                    <i class="fa fa-star-o" aria-hidden="true" style="margin-right: 3px;font-size: 16px;"></i>收藏
                  </el-link>
                </el-tooltip>
                <el-tooltip effect="dark" content="取消收藏" placement="top" v-else>
                  <el-link style="font-size: 12px;" @click="updateCollect">
                    <i class="fa fa-star" aria-hidden="true" style="margin-right: 3px;color: #FFD700;font-size: 16px;"></i>已收藏
                  </el-link>
                </el-tooltip>
              </div>
              <div style="display: flex;flex-wrap: nowrap;font-size: 12px;line-height: 24px;margin: 0 10px">
                <div class="help-button-left" :style="getStyle()" :class="getClass('help')" @click="updateKnowledgeHelp(true)">
                  <i class="fa fa-thumbs-o-up" aria-hidden="true" style="margin-right: 3px;font-size: 14px"></i>有帮助
                </div>
                <div class="help-button-right" :style="getStyle()" :class="getClass('noHelp')" @click="updateKnowledgeHelp(false)">
                  <i class="fa fa-thumbs-o-down" aria-hidden="true" style="margin-right: 3px;font-size: 14px"></i>没帮助
                </div>
              </div>
            </div>
          </div>
          <div>
            <div style="font-weight: bold">标签：</div>
            <div style="display: flex;flex-wrap: wrap">
              <el-tag class="tag" type="success" v-for="item in knowledgeDetail.tagList" :key="item">{{item}}</el-tag>
            </div>
          </div>
        </div>
        <div class="background" v-for="item in knowledgeDetail.answerList" :key="item.id">
          <div style="display: flex;flex-wrap: nowrap">
            <div style="width: 3px;background-color: #409eff;height: 40px;margin-right: 10px;margin-top: 7px"></div>
            <div>
              <div style="font-weight: bold;font-size: 20px">{{ item['name@create_user_id'] }}</div>
              <div style="font-size: 14px;color: #8A919F">编辑于 {{ item.create_time }}</div>
            </div>
          </div>
          <div style="background: #8A919F;height: 0.5px"></div>
          <div class="answer">
            <KfCkEditor type="textarea" :readonly="true" :rows="15" v-model="item.answer"></KfCkEditor>
          </div>
          <div style="background: #8A919F;height: 0.5px"></div>
          <div style="margin-top: 20px">
            <div style="width: 100px;font-weight: bold;font-size: 20px;display: flex;flex-wrap: nowrap">
              <div style="width: 3px;background-color: #409eff;height: 24px;margin-right: 10px;margin-top: 4px"></div>附件：
            </div>
            <div class="doc-list">
              <div class="doc-link" v-for="file in item.fileList" :key="file.id">
                <text class="doc-link-text" @click="downloadFile(file)">{{file.original_name}}</text>
              </div>
            </div>
          </div>
        </div>
        <div class="background">
          <div style="width: 100px;font-weight: bold;font-size: 20px;display: flex;flex-wrap: nowrap;margin-bottom: 20px">
            <div style="width: 3px;background-color: #409eff;height: 24px;margin-right: 10px;margin-top: 4px"></div>我要回答
          </div>
          <div class="inputAnswer">
            <KfCkEditor type="textarea" :readonly="false" :rows="15" v-model="answer.answerContent"></KfCkEditor>
          </div>
          <FrameItem v-model="answer.fileIds" :item="uploadOptions"/>
          <el-button type="success" style="margin-top: 20px" @click="submitAnswer">提交回答</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "KnowledgeInfo",
  components: {},
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      knowledgeDetail:{},
      uploadOptions: {"component":"file_upload", "span":18, "label":"附件", "required":false, "drag":true, "limit": 30},
      answer:{answerContent: '', fileIds: []},
    }
  },
  methods: {
    async updateKnowledgeHelp(isHelp){
      if (this.knowledgeDetail.is_help !== undefined){
        return
      }
      await this.$http('prjKnowledgeService.updateKnowledgeHelp',{id:this.parentData.id,is_help:isHelp})
      this.$message.success("操作成功");
      this.knowledgeDetail.is_help = isHelp
    },
    async updateCollect(){
      await this.$http('prjKnowledgeService.updateCollect',{id:this.parentData.id})
      this.$message.success("操作成功");
      this.knowledgeDetail.is_collect = !this.knowledgeDetail.is_collect
    },
    async getKnowledgeDetail() {
      this.knowledgeDetail = await this.$http('prjKnowledgeService.getKnowledgeDetail',{id:this.parentData.id})
    },
    getClass(key){
      if (this.knowledgeDetail.is_help === undefined){
        return ''
      }
      if (!this.knowledgeDetail.is_help && key === 'help'){
        return 'disabled'
      }
      if (this.knowledgeDetail.is_help && key === 'noHelp'){
        return 'disabled'
      }
    },
    getStyle(){
      if (this.knowledgeDetail.is_help === undefined){
        return 'cursor: pointer'
      }else {
        return 'cursor: not-allowed'
      }
    },
    async submitAnswer() {
      this.answer.knowledge_id = this.knowledgeDetail.id
      await this.$http('prjKnowledgeService.addKnowledgeAnswer', this.answer)
      this.$message.success("操作成功");
      this.getKnowledgeDetail()
      this.answer = {answerContent: '', fileIds: []}
    },
    downloadFile(file) {
      let url = file.url;
      if (!url) {
        return
      }
      let name = file.name

      const a = document.createElement('a')

      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + (url.startsWith('/') ? '' : '/') + url;
      }
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        a.download = name || '' // 下载文件的名字
        document.body.appendChild(a)
        a.click()

        //在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      })
    },
  },
  created() {
    this.getKnowledgeDetail()
  }
}
</script>
<style lang="less" scoped>
@import '@/global.less';
.disabled{
  background-color: #e4e8ee !important;
  color: #c4c7cc !important;
}
.help-button-left{
  height: 24px;
  margin-right: 3px;
  background-color: #E4EDF8;
  color: #0064C8;
  padding: 0 10px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.help-button-right{
  height: 24px;
  margin-right: 3px;
  background-color: #F9EEE9;
  color: #FF6A00;
  padding: 0 10px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.tag{
  margin: 3px 2px;
}
.doc-link{
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  height: 25px;
  line-height: 25px;
  color: #409eff;
}
.doc-link-text{
  cursor: pointer;
}
.doc-link-text:hover{
  border-bottom: 1px solid #409eff;
}
.doc-list {
  width: 660px;
  margin-left: 100px;
}
.info-box-left > div{
  margin-bottom: 10px;
}
.answer ::v-deep(.ck.ck.ck-content){
  border: none !important;
}
.inputAnswer{
  margin-bottom: 20px;
}
.inputAnswer ::v-deep(.ck.ck.ck-content){
  min-height: 200px !important;
}
.background{
  padding: 30px;
  background-color: #FFFFFF;
}
.info-box{
  display: flex;
  justify-content: center;
  background-color: #f2f3f5;
  min-width: 900px;
  width: 100%;
  overflow: auto;
  padding-top: 10px;
}
.info-box-left{
  width: 820px;
}
</style>
